<!--
 * @Description: 教学计划科目 详情
 * @Author: PF
 * @Date: 2023-04-13 18:30:06
 * @LastEditors: PF
 * @LastEditTime: 2024-10-18 17:46:23
-->
<template>
  <div>
    <el-dialog class="w600 h500" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-descriptions :column="2" border class="mb10">
        <el-descriptions-item label="科目" label-align="right" align="left" width="140px" span="2">{{ruleForm.kskmmc}}</el-descriptions-item>
        <el-descriptions-item label="考试方式" label-align="right" align="left" width="140px" span="2">
          <span v-for="(item, index) in ksfsData.list" :key="index" >
            <span v-if="item.id === ruleForm.ksfsid">{{ item.name }}</span>
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="组卷负责人" label-align="right" align="left" span="2">{{ruleForm.zjrxm}}</el-descriptions-item>
        <el-descriptions-item label="试卷审核人" label-align="right" align="left" span="2">{{ruleForm.sjshrxm}}</el-descriptions-item>
        <el-descriptions-item label="排考方式" label-align="right" align="left" span="2">
          <span v-for="(item, index) in pkfsData.list" :key="index" >
            <span v-if="item.value === ruleForm.pkfs">{{ item.name }}</span>
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="录入成绩方式" label-align="right" align="left" span="2">
          <span v-for="(item, index) in lrcjfsData.list" :key="index" >
            <span v-if="item.value === ruleForm.lrcjfs">{{ item.name }}</span>
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="是否统一时间考试" label-align="right" align="left" span="2">
          <span v-if="ruleForm.sftysjks===true">是</span>
          <span v-if="ruleForm.sftysjks===false">否</span>
        </el-descriptions-item>
      </el-descriptions>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="info" @click="closeWindow('openDetail', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch } from 'vue'
import { loadSelect, closeWindow } from '@/api/common.js'
import { getKsfs } from '@/utils/zidianmeiju'

const props = defineProps({ openDetail: { type: Boolean, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['update:openDetail', 'ReturnData'])

const ruleForm = ref({})
const ksfsData = ref({ list: [] }) // 加载 考试方式 下拉框
const pkfsData = ref({ list: [] }) // 排考方式
const lrcjfsData = ref({ list: [] }) // 录入成绩方式

watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      ksfsData.value = getKsfs()
      loadSelect({ url: '/api/v2/jiaowu/kaowukaoshikemu/paikaofangshi', data: pkfsData })
      loadSelect({ url: '/api/v2/jiaowu/kaowukaoshijihua/luruchengjifangshi', data: lrcjfsData })
      ruleForm.value = props.row
    }
  },
  { deep: true, immediate: true }
)
</script>
